// MUI Components
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function Leaderboard({ data, loading, localNickname }) {
  const { theme } = useTheme();

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        minHeight: 160
      }}>
        <CircularProgress
          size={36}
          sx={{
            color: theme.color.primary,
            '@keyframes pulse': {
              '0%': { opacity: 0.7, transform: 'scale(0.97)' },
              '50%': { opacity: 1, transform: 'scale(1.03)' },
              '100%': { opacity: 0.7, transform: 'scale(0.97)' }
            },
            animation: 'pulse 1.8s infinite ease-in-out'
          }}
        />
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 2,
          p: 1,
          borderRadius: 1.5,
          background: `${theme.color.primary}15`,
        }}>
          <Typography variant="body1" color={theme.text.secondary} fontFamily={theme.fontFamily}>
            Loading leaderboard data
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <TableContainer sx={{
      mb: 3,
      borderRadius: 2,
      bgcolor: theme.background.secondary,
      border: `1px solid ${theme.border.light}`,
      overflow: 'hidden',
      minWidth: "550px",
      maxWidth: "500px"
    }}>
      <Table size="medium">
        <TableHead>
          <TableRow sx={{ bgcolor: theme.background.tertiary }}>
            <TableCell sx={{ fontWeight: 700, color: theme.text.primary, fontSize: '0.95rem', fontFamily: theme.fontFamily }}>Nickname</TableCell>
            <TableCell align="center" sx={{ fontWeight: 700, color: theme.text.primary, fontSize: '0.95rem', fontFamily: theme.fontFamily }}>Points</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow
              key={idx}
              sx={{
                bgcolor: idx % 2 === 0 ? 'transparent' : theme.background.tertiary,
                '&:last-child td': { borderBottom: 0 },
              }}
            >
              <TableCell sx={{ fontWeight: row.nickname === localNickname ? 700 : 400, fontFamily: theme.fontFamily }}>{row.nickname}</TableCell>
              <TableCell align="center" sx={{ fontWeight: row.nickname === localNickname ? 700 : 400, fontFamily: theme.fontFamily }}>{row.points}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
